module.exports = __webpack_public_path__ + "static/media/hero-image.561e1c59.webp";